"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApiAdvertisingRepo = createApiAdvertisingRepo;
const AdvertisingMachine_1 = require("../domain/AdvertisingMachine");
const AdvertisingMachineMapper_1 = require("./mappers/AdvertisingMachineMapper");
const AdMapper_1 = require("./mappers/AdMapper");
const AdMachineMapper_1 = require("./mappers/AdMachineMapper");
const MachineSummaryMapper_1 = require("./mappers/MachineSummaryMapper");
const MachineAdMapper_1 = require("./mappers/MachineAdMapper");
const HTTPClient_1 = require("../../../common/api/HTTPClient");
const http_helpers_1 = require("../../../common/api/http-helpers");
const getApiUrl_1 = require("../../../common/api/utils/getApiUrl");
const ItemList_1 = require("../../../common/models/ItemList");
// TODO: Reemplazar por los endpoints reales del microservicio
// ms-vending-machine-v2 cuando estén disponibles. De momento las llamadas
// apuntan al mock de WireMock.
const ADVERTISING_MACHINES_URL = 'https://d4wlw.wiremockapi.cloud/vnd-machine/v1/advertising/machines';
const ADVERTISING_ADS_URL = 'https://d4wlw.wiremockapi.cloud/vnd-machine/v1/advertising/ads';
function createApiAdvertisingRepo() {
    return {
        getMachines,
        getMachinesSummary,
        setMachineAdvertising,
        getAds,
        getAdMachines,
        createAd,
        getAd,
        updateAd,
        deleteAd,
        getAdUploadUrl,
        getMachineAds,
        saveMachineAds,
        getAvailableAds,
    };
}
async function getMachinesSummary() {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`${ADVERTISING_MACHINES_URL}/summary`),
        });
        return (res.items ?? []).map(MachineSummaryMapper_1.mapToDomainMachineSummary);
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return [];
    }
}
async function getAdUploadUrl(file) {
    const res = await HTTPClient_1.HTTPClient.post({
        url: (0, getApiUrl_1.getApiUrl)(`${ADVERTISING_ADS_URL}/upload-url`),
        type: 'json',
        body: { contentType: file.type },
    });
    return res;
}
// TODO: con backend real, entre getAdUploadUrl y createAd hace falta un
// PUT del File al `uploadUrl` devuelto por S3. El mock no lo necesita.
async function createAd(payload) {
    const res = await HTTPClient_1.HTTPClient.post({
        url: (0, getApiUrl_1.getApiUrl)(ADVERTISING_ADS_URL),
        type: 'json',
        body: payload,
    });
    return (0, AdMapper_1.mapToDomainAd)(res);
}
// Deja propagar el error: el modal de edición necesita saber si el detalle
// no se ha podido cargar para avisar al usuario y cerrarse.
async function getAd(adId) {
    const res = await HTTPClient_1.HTTPClient.get({
        url: (0, getApiUrl_1.getApiUrl)(`${ADVERTISING_ADS_URL}/${adId}`),
    });
    return (0, AdMapper_1.mapToDomainAdDetail)(res);
}
async function updateAd(adId, payload) {
    const res = await HTTPClient_1.HTTPClient.put({
        url: (0, getApiUrl_1.getApiUrl)(`${ADVERTISING_ADS_URL}/${adId}`),
        type: 'json',
        body: payload,
    });
    return (0, AdMapper_1.mapToDomainAdDetail)(res);
}
// Deja propagar el error para que la UI mantenga abierto el modal de
// confirmación, avise al usuario y permita reintentar el borrado.
async function deleteAd(adId) {
    await HTTPClient_1.HTTPClient.delete({
        url: (0, getApiUrl_1.getApiUrl)(`${ADVERTISING_ADS_URL}/${adId}`),
    });
}
async function getMachines() {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(ADVERTISING_MACHINES_URL),
        });
        return (0, AdvertisingMachineMapper_1.mapToDomainAdvertisingMachineList)(res);
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return (0, AdvertisingMachine_1.emptyAdvertisingMachineList)();
    }
}
// A diferencia de getMachines, esta mutación deja propagar el error para que la
// UI pueda mantener abierto el modal de confirmación y permitir reintentar.
async function setMachineAdvertising(machineId, advertisingEnabled) {
    const res = await HTTPClient_1.HTTPClient.patch({
        url: (0, getApiUrl_1.getApiUrl)(`${ADVERTISING_MACHINES_URL}/${machineId}`),
        type: 'json',
        body: { advertisingEnabled },
    });
    return (0, AdvertisingMachineMapper_1.mapToDomainAdvertisingMachine)(res);
}
async function getAds(page = 1, pageSize = 10) {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(ADVERTISING_ADS_URL),
            params: { page, pageSize },
        });
        return {
            items: res.items.map(AdMapper_1.mapToDomainAd),
            pagination: res.pagination,
        };
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return (0, ItemList_1.emptyList)();
    }
}
async function getAdMachines(adId, page = 1, pageSize = 10) {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`${ADVERTISING_ADS_URL}/${adId}/machines`),
            params: { page, pageSize },
        });
        return {
            items: (res.items ?? []).map(AdMachineMapper_1.mapToDomainAdMachine),
            pagination: res.pagination,
        };
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return (0, ItemList_1.emptyList)();
    }
}
async function getMachineAds(machineId) {
    try {
        // Mock devuelve la máquina con `ads` embebidos en la misma URL del PATCH.
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`${ADVERTISING_MACHINES_URL}/${machineId}`),
        });
        return (0, MachineAdMapper_1.mapToDomainMachineAdsView)(res);
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return { machine: null, ads: [] };
    }
}
async function saveMachineAds(machineId, payload) {
    const res = await HTTPClient_1.HTTPClient.put({
        url: (0, getApiUrl_1.getApiUrl)(`${ADVERTISING_MACHINES_URL}/${machineId}/ads`),
        type: 'json',
        body: payload,
    });
    return (0, MachineAdMapper_1.mapToDomainMachineAdsView)(res);
}
async function getAvailableAds(machineId) {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`${ADVERTISING_MACHINES_URL}/${machineId}/available-ads`),
        });
        return (res.items ?? []).map(AdMapper_1.mapToDomainAd);
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return [];
    }
}
